import React from "react";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";

// Create styles
const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 11,
    fontFamily: "Helvetica",
  },
  header: {
    fontSize: 20,
    marginBottom: 20,
    textAlign: "center",
  },
  tableHeader: {
    flexDirection: "row",
    borderBottom: "1px solid #000",
    paddingBottom: 5,
    marginBottom: 5,
  },
  tableRow: {
    flexDirection: "row",
    marginBottom: 4,
  },
  colSmall: {
    width: "10%",
  },
  colMed: {
    width: "20%",
  },
  colLarge: {
    width: "50%",
  },
  textBold: {
    fontWeight: 700,
  },
});

// PDF Component
export default function PricelistReportPDF({ pricelist, products }) {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Text style={styles.header}>Price List Report</Text>
        <Text>Pricelist Name: {pricelist.pricelistName}</Text>

        <View style={{ marginTop: 20 }}>
          <View style={styles.tableHeader}>
            <Text style={[styles.colSmall, styles.textBold]}>ID</Text>
            <Text style={[styles.colMed, styles.textBold]}>Code</Text>
            <Text style={[styles.colLarge, styles.textBold]}>Name</Text>
            <Text style={[styles.colMed, styles.textBold]}>Price</Text>
          </View>

          {products.map((p) => (
            <View key={p.productId} style={styles.tableRow}>
              <Text style={styles.colSmall}>{p.productId}</Text>
              <Text style={styles.colMed}>{p.productCode}</Text>
              <Text style={styles.colLarge}>{p.productName}</Text>
              <Text style={styles.colMed}>${p.productPrice?.toFixed(2)}</Text>
            </View>
          ))}
        </View>
      </Page>
    </Document>
  );
}
